import { GraphBar } from "../../graph/GraphBar";
import { Mappable } from "../../../_shared/mappable.class";

export interface Cue5050BaseReport extends Mappable<Cue5050BaseReport> {

    cue5050Id: number;
    name: string;
    eventStartDate: Date;
    eventEndDate: Date;

    getBarMappingsByBreakdownType(type: BreakdownType): GraphBar;

    getBreakdownTypes(): BreakdownType[];

    getBreakdownByBreakdownType(type: BreakdownType): string[];
    
    getYAxisName(): string;

    getXAxisName(): string;
}

export enum ReportType {
    FinancialReport = 1,
    WhosPlaying = 2,
    PurchaseDetails = 3
}

export enum BreakdownType {
    SalesByPaymentMethod = 1,
    SalesByFeesAndNet = 2,
    SalesByStation = 3,

    PlayersByReturning = 4,

    OrdersByPaymentMethod = 5,
    OrderByStation = 6,
    OrdersByTicketTier = 7
}